var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"rounded-circle d-block m-auto success-gif",attrs:{"src":_vm.randomGif,"height":_vm.size,"width":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }